import { render, staticRenderFns } from "./MainCanvas.vue?vue&type=template&id=ee243e52&scoped=true"
import script from "./MainCanvas.vue?vue&type=script&lang=js"
export * from "./MainCanvas.vue?vue&type=script&lang=js"
import style0 from "./MainCanvas.vue?vue&type=style&index=0&id=ee243e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee243e52",
  null
  
)

export default component.exports